import React from 'react';
import { type RouteObject } from 'react-router-dom';

import { OWNERS_HUB_ROUTES } from '@/constants/routes';

import TelegramCallback from './index';

/**
 * `/telegram-callback` — the Telegram OIDC code-flow landing. Standalone, full-bleed, NOT auth-gated
 * (the browser arrives here from the provider with no app session yet). Registered before the
 * config-driven routes in `src/routes.tsx`.
 */
export const telegramCallbackRoute: RouteObject = {
  path: OWNERS_HUB_ROUTES.TELEGRAM_CALLBACK,
  element: <TelegramCallback />,
};

export default telegramCallbackRoute;
